import React from 'react';
import { diskUnitFormatM } from '@/utils/device';
import styles from '../index.less';

const DiskCard = ({ isX86, isDC, diskInfo }) => {
  const { hd_total, hd_used, disk_type_name, fs_type_text } = diskInfo;
  const rate = (Number(hd_used) / Number(hd_total)) * 100;

  return (
    <>
      {(hd_total || Number(hd_total) > 0) && (
        <div className={styles['monitor-disk-card']}>
          <h2 className={styles['disk-card-header']}>磁盘</h2>
          <div className={styles['disk-used-info']}>
            <span className={styles['disk-info-name']}>磁盘缓存</span>
            <span className={styles['disk-used-num']}>
              <em>
                {diskUnitFormatM(hd_used)}/{diskUnitFormatM(hd_total)}
              </em>
            </span>
          </div>
          <div className={styles['barbg']}>
            <div className={styles['bar']} style={{ width: `${rate}%` }}></div>
          </div>
          {!isX86 && (
            <div className={styles['disk-card-footer']}>
              {!isDC && (
                <span className={styles['disk-info-name']}>
                  磁盘类型<em>{disk_type_name}</em>
                </span>
              )}
              <span className={styles['disk-info-name']}>
                文件系统<em>{fs_type_text}</em>
              </span>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default DiskCard;
